import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import {
  Form,
  Button
} from 'semantic-ui-react'

import {
  post
} from '_utils/xhr'

import {
  getValue
} from '_utils'

import CreateModalWrapper from '_forms/createModal'

const role = {
  name: '',
  description: ''
}

class AddRoleModal extends React.PureComponent {
  state = {
    open: false,
    role: R.merge({}, role),
    dirty: false,
    msg: {
      fetching: false,
      visible: false,
      errorMessage: null
    }
  }

  onDismiss = () => {
    this.setState({msg: R.merge(this.state.msg, {visible: false})})
  }

  onSubmit = (e, data) => {
    e.preventDefault()
    const urlPath = '/roles'
    post(
      urlPath,
      this.state.role
    )
      .then(body => {
        if (this.props.onCreate) {
          this.props.onCreate(body)
        }
        this.setState({
          dirty: false,
          open: false,
          msg: {errorMessage: null, visible: false, fetching: false},
          role: R.merge({}, role)
        })
      })
      .catch(err => this.setState({msg: {errorMessage: err.message, visible: true, fetching: false}}))
  }

  onChange = (e, data) => this.setState({
    role: R.merge(this.state.role, {[data.name]: getValue(data)}),
    dirty: true
  })

  onCancel = () => this.setState({
    role: role,
    open: false,
    msg: {errorMessage: null, visible: false, fetching: false},
    dirty: false
  })

  onOpen = () => this.setState({open: true})

  render () {
    return (
      <CreateModalWrapper
        open={this.state.open}
        onOpen={this.onOpen}
        onClose={this.onCancel}

        onDismiss={this.onDismiss}
        {...this.state.msg}
        header='Create a new role'
        subHeader='... for assigning permissions and groups'
        type='role'
        iconName='plus'
        iconHeader='Add Role'
      >
        <Form size='tiny' onSubmit={this.onSubmit}>
          <Form.Group>
            <Form.Input
              width={4}
              label='Name'
              name='name'
              placeholder='name of role (eg. beta)'
              value={R.path(['role', 'name'], this.state)}
              onChange={this.onChange}
            />
            <Form.Input
              width={12}
              label='Description'
              name='description'
              placeholder='short description'
              value={R.path(['role', 'description'], this.state)}
              onChange={this.onChange}
            />
          </Form.Group>
          <Button.Group>
            <Button onClick={this.onCancel}>Cancel</Button>
            <Button.Or />
            <Button positive={this.state.dirty} disabled={!this.state.dirty} type="submit">Create</Button>
          </Button.Group>
        </Form>
      </CreateModalWrapper>
    )
  }
}

AddRoleModal.propTypes = {
  onCreate: PropTypes.func
}

export default AddRoleModal



// WEBPACK FOOTER //
// ./webAdmin/components/users/addRole.js